import * as _ from 'lodash';


export const prettifySize = (bytes: any): string => {
  if (bytes === undefined || bytes === null || bytes === '') { return null; }
  if (typeof bytes === 'string') {
    bytes = parseFloat(bytes);
  }
  const sizes = ['bytes', 'kb', 'MB', 'GB', 'TB'];
  if (bytes === 0) { return 'n/a'; }
  const i = parseInt(`${Math.floor(Math.log(bytes) / Math.log(1024))}`, 10);
  if (i === 0) { return `${bytes} ${sizes[i]}`; }
  return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
};

export const prettifyNumber = (number: Number|string, separator: string, decimalPlaces?: number): string => {
  if (typeof(number) === 'string') {
    try {
      number = Number(number);
      if (!_.isNil(decimalPlaces)) {
        number = number.toFixed(decimalPlaces);
      }
    } catch (e) {
      console.log(e);
    }
  }
  if (number !== null && number !== undefined) {
    const n = number.toString();
    return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, `$1${separator}`);
  }
  return '';
};
